import { toPlainText } from "@portabletext/react";
import React from "react";
import BlogSidebar from "../components/blog/sidebar";
import Seo from "../components/common/seo";
import { Link } from "gatsby";

const Video = ({ pageContext }) => {
  const { video } = pageContext;

  return (
    <div className="videopage container">
      <div className="left">
        <h1>{video.title}</h1>
        {video.video && (
          <iframe src={video.video} className="w-full aspect-video video" />
        )}
        <div
          className="description"
          dangerouslySetInnerHTML={{
            __html: video.body,
          }}
        />
        {!!video?.categories?.length && (
          <div className="tag__container">
            <h6>
              Categories:
              <div className="space-x-1 ml-2 pl-0 inline-block">
                {video?.categories?.map((category, index) => (
                  <Link key={index} to={`/${category.slug}`}>
                    <span>{category.name}</span>{" "}
                    {video.categories?.length > index + 1 && ","}
                  </Link>
                ))}
              </div>
            </h6>
          </div>
        )}
        {!!video?.tags?.length && (
          <div className="tag__container">
            <h6>
              Tags:
              <ul className="space-x-1 ml-2 pl-0 inline-block">
                {video?.tags?.map((tag, index) => (
                  <Link key={index} to={`/${tag.slug}`}>
                    <span>{tag.name}</span>
                    {video.tags?.length > index + 1 && ","}
                  </Link>
                ))}
              </ul>
            </h6>
          </div>
        )}
      </div>
      <div className="right">
        <BlogSidebar
          iframes={[
            "99ab7fb5-003b-4946-b867-6193fbbf97e1",
            "99ab7fea-d2b0-48ad-90d8-f76d44ffe13e",
          ]}
        />
      </div>
    </div>
  );
};

export function Head({ location, pageContext }) {
  const { video } = pageContext;
  const seoData = {
    title: video?.title,
    description: video.body ? toPlainText(video.body) : "",
  };

  return <Seo location={location} data={seoData} />;
}

export default Video;
